import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { Polizza } from 'src/app/models/polizza';
import { PolizzaService } from 'src/app/services/polizza.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { PolizzeFormComponent } from './dialogs/form/form.component';
import { formatDate } from '@angular/common';
import { Incarico } from 'src/app/models/incarico';
import { IncaricoService } from '../../services/incarico.service';

@Component({
  selector: 'polizze',
  templateUrl: './polizze.component.html',
  styleUrls: ['./polizze.component.scss']
})
export class PolizzeComponent implements OnInit {

  headingText: string = 'Polizze';

  relations: string[] = ['compagnia', 'agenzia', 'ramo', 'contraente', 'fabbricato', 'contraente.comune'];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any;

  incarico: Incarico;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'Numero',
        internalName: 'numero',
        type: 'link',
        href: (model) => model.id,
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Compagnia',
        internalName: 'compagnia',

        displayFunction: (model) => model.compagnia?.nome,
        sortDisabled: true,
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Agenzia',
        internalName: 'agenzia',

        displayFunction: (model) => model.agenzia?.nome,
        sortDisabled: true,
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Ramo',
        internalName: 'ramo',

        displayFunction: (model) => model.ramo?.nome,
        sortDisabled: true,
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Contraente',
        internalName: 'contraente',

        displayFunction: (model: Polizza) => model.contraente?.humanIdentifier,
        sortDisabled: true,
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Data Decorrenza',
        internalName: 'data_decorrenza',
        displayFunction: model => model?.data_decorrenza ? formatDate(model?.data_decorrenza, 'dd/MM/yyyy', 'it-IT') : '',
      }
    ),
  ];
  constructor(public polizzaService: PolizzaService,
    public dialog: MatDialog,
    private toast: ToastrService,
    @Optional() private dialogRef: MatDialogRef<PolizzeComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,) {
    this.incarico = data?.incarico;
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona una polizza';
    };
  }

  async ngOnInit() {

  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateData();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateData() {
    await this.index?.updateData();
  }

  deleteFunction = async (polizza: Polizza) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare la polizza ${polizza.humanIdentifier}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.polizzaService.delete(polizza);
          this.toast.success('Polizza eliminata.');
          this.updateData();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione polizza fallita.", "Errore!");
    }
  }



  editFunction = async (polizza: Polizza) => {
    let dialogRef = this.dialog.open(PolizzeFormComponent, { data: polizza });
    dialogRef.afterClosed().subscribe((data: Polizza) =>
      this.updateData()
    );
  }


  add() {
    let addDialogRef = this.dialog.open(PolizzeFormComponent, { 
      data: { 
        search: this.search, 
        incarico: this.incarico 
      }
    });
    
    addDialogRef.afterClosed().subscribe(async (newPolizza: Polizza) => {
      if (newPolizza) {
        try {
          if (this.selectionMode) {
            this.closeDialogWithSelectedModel(newPolizza);
            return;
          }
          
          this.updateData();
        } catch (error) {
          this.toast.error('Errore nell\'associazione della polizza all\'incarico');
        }
      }
    });
  }
}
